module.exports = __webpack_public_path__ + "img/dark_ic_creation_step2.1739c62c.png";